import type { CSSProperties } from 'react';

import type { StartBusinessType } from 'router/params/startBusinessType';

type BusinessTypeOptionCardPart = 'card' | 'illustration' | 'typeHeader';

export const BUSINESS_TYPE_OPTION_CARD_VIEW_TRANSITION_CLASS = {
  card: 'business-type-option-card',
  illustration: 'business-type-option-card-illustration',
  typeHeader: 'business-type-option-card-type-header',
} as const satisfies Record<BusinessTypeOptionCardPart, string>;

export function getBusinessTypeOptionCardViewTransitionStyle(
  part: BusinessTypeOptionCardPart,
  businessType: StartBusinessType,
) {
  const viewTransitionClass =
    BUSINESS_TYPE_OPTION_CARD_VIEW_TRANSITION_CLASS[part];

  return {
    viewTransitionName: `${viewTransitionClass}-${businessType}`,
    viewTransitionClass,
  } satisfies CSSProperties;
}

export const matchedViewTransitionBox = {
  width: 'fit-content',
} as const satisfies CSSProperties;
